import React, { useEffect, useState } from "react";
import axios from "axios";

const RevenueByPlan = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchRevenue = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/admin/analytics/revenue/by-plan`
        );
        setData(res.data);
      } catch (error) {
        console.error("Error fetching revenue by plan:", error);
      }
    };
    fetchRevenue();
  }, []);

  return (
    <div className="widget">
      <h3>Revenue by Plan</h3>
      <ul>
        {data.length === 0 && <li>No data</li>}
        {data.map((item) => (
          <li key={item.planName}>
            {item.planName}: ₹{item.totalRevenue}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default RevenueByPlan;
